<div class="landing-shell min-h-screen flex flex-col font-outfit">
  <!-- Sticky Header -->
  <header 
    class="fixed top-0 left-0 z-50 w-full transition-all duration-300 border-b border-transparent px-6 py-4"
    [class.scrolled]="isScrolled"
  >
    <div class="max-w-7xl mx-auto flex items-center justify-between">
      <a routerLink="/" class="flex items-center gap-2 group decoration-none!">
        <div
          class="w-10 h-10 rounded-xl bg-gradient-primary flex items-center justify-center shadow-glow group-hover:scale-105 transition-transform"
        >
          <img src="assets/images/logos/logo_icon.png" alt="Logo" class="w-6 h-6 object-contain" />
        </div>
        <span class="text-xl font-bold tracking-tight text-foreground hidden sm:block uppercase">
          DENTIUM SYS
        </span>
      </a>

      <!-- Desktop Nav -->
      <nav class="hidden md:flex items-center gap-8">
        <a [routerLink]="['/']" fragment="features" class="text-sm font-medium text-text-muted hover:text-primary transition-colors decoration-none!">Ecosistema</a>
        <a [routerLink]="['/']" fragment="pricing" class="text-sm font-medium text-text-muted hover:text-primary transition-colors decoration-none!">Suscripciones</a>
        <a [routerLink]="['/']" fragment="faq" class="text-sm font-medium text-text-muted hover:text-primary transition-colors decoration-none!">FAQ</a>
        <div class="h-4 w-px bg-border-primary/50"></div>
        <a routerLink="/auth/login" class="text-sm font-semibold text-foreground hover:text-primary transition-colors decoration-none!">Iniciar Sesión</a>
        <a
          routerLink="/auth/login"
          class="px-5 py-2.5 rounded-full bg-gradient-primary text-white text-sm font-semibold hover-lift shadow-premium decoration-none!"
        >
          Probar Gratis
        </a>
      </nav>

      <!-- Mobile Toggle -->
      <button (click)="toggleMenu()" class="md:hidden p-2 text-text-muted">
        <iconify-icon [icon]="isMenuOpen ? 'mdi:close' : 'mdi:menu'" class="text-2xl"></iconify-icon>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div
      *ngIf="isMenuOpen"
      class="absolute top-full left-0 w-full glass border-b border-white/10 py-6 px-6 flex flex-col gap-4 md:hidden animate-fade-in"
    >
      <a [routerLink]="['/']" fragment="features" (click)="toggleMenu()" class="text-lg font-medium text-foreground py-2 border-b border-border-primary/30 decoration-none!">Ecosistema</a>
      <a [routerLink]="['/']" fragment="pricing" (click)="toggleMenu()" class="text-lg font-medium text-foreground py-2 border-b border-border-primary/30 decoration-none!">Suscripciones</a>
      <a [routerLink]="['/']" fragment="faq" (click)="toggleMenu()" class="text-lg font-medium text-foreground py-2 border-b border-border-primary/30 decoration-none!">FAQ</a>
      <div class="flex flex-col gap-3 pt-4">
        <a
          routerLink="/auth/login"
          class="w-full py-3 text-center rounded-xl bg-surface-hover text-foreground font-semibold decoration-none!"
        >
          Iniciar Sesión
        </a>
        <a
          routerLink="/auth/login"
          class="w-full py-3 text-center rounded-xl bg-gradient-primary text-white font-semibold shadow-premium decoration-none!"
        >
          Empezar Ahora
        </a>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <main class="flex-grow pt-[76px]">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <footer class="bg-surface py-20 border-t border-border-primary/50">
    <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div class="space-y-6">
        <div class="flex items-center gap-2">
          <img src="assets/images/logos/logo_icon.png" alt="Logo" class="w-8 h-8 object-contain" />
          <span class="text-xl font-bold tracking-tight text-foreground uppercase">DENTIUM SYS</span>
        </div>
        <p class="text-text-muted leading-relaxed max-w-xs">
          La plataforma definitiva para la gestión de clínicas dentales. Digitalizamos tu pasión por la salud.
        </p>
        <div class="flex gap-4">
          <a href="#" class="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-primary/10 transition-colors">
            <iconify-icon icon="mdi:instagram" class="text-xl text-primary"></iconify-icon>
          </a>
          <a href="#" class="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-primary/10 transition-colors">
            <iconify-icon icon="mdi:facebook" class="text-xl text-primary"></iconify-icon>
          </a>
          <a href="#" class="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-primary/10 transition-colors">
            <iconify-icon icon="mdi:twitter" class="text-xl text-primary"></iconify-icon>
          </a>
        </div>
      </div>

      <div>
        <h4 class="text-sm font-bold uppercase tracking-widest text-foreground mb-6">Plataforma</h4>
        <ul class="space-y-4">
          <li><a [routerLink]="['/']" fragment="features" class="text-text-muted hover:text-primary transition-colors decoration-none!">Funcionalidades</a></li>
          <li><a [routerLink]="['/']" fragment="pricing" class="text-text-muted hover:text-primary transition-colors decoration-none!">Planes y Precios</a></li>
          <li><a href="#" class="text-text-muted hover:text-primary transition-colors decoration-none!">Demo Online</a></li>
        </ul>
      </div>

      <div>
        <h4 class="text-sm font-bold uppercase tracking-widest text-foreground mb-6">Empresa</h4>
        <ul class="space-y-4">
          <li><a href="#" class="text-text-muted hover:text-primary transition-colors decoration-none!">Sobre nosotros</a></li>
          <li><a href="#" class="text-text-muted hover:text-primary transition-colors decoration-none!">Contacto</a></li>
          <li><a href="#" class="text-text-muted hover:text-primary transition-colors decoration-none!">Soporte técnico</a></li>
        </ul>
      </div>

      <div>
        <h4 class="text-sm font-bold uppercase tracking-widest text-foreground mb-6">Legal</h4>
        <ul class="space-y-4">
          <li><a href="#" class="text-text-muted hover:text-primary transition-colors decoration-none!">Términos y condiciones</a></li>
          <li><a href="#" class="text-text-muted hover:text-primary transition-colors decoration-none!">Política de privacidad</a></li>
          <li><a href="#" class="text-text-muted hover:text-primary transition-colors decoration-none!">Cookies</a></li>
        </ul>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-6 mt-20 pt-8 border-t border-border-primary/20 flex flex-col md:flex-row items-center justify-between gap-4">
      <p class="text-sm text-text-muted">
        © {{ currentYear }} DENTIUM SYS. Todos los derechos reservados.
      </p>
      <p class="text-sm text-text-muted flex items-center gap-1">
        Hecho con <iconify-icon icon="mdi:heart" class="text-error"></iconify-icon> por VIKOR
      </p>
    </div>
  </footer>
</div>
